import { Select, MenuItem, Switch, FormControlLabel, Box, Typography, Grid, ButtonBase } from '@mui/material';
import FieldWrapper from '../FieldWrapper';
import { Users, User } from 'lucide-react';

const PARENTELA_OPTIONS = ['Coniuge', 'Convivente', 'Altra Parentela', 'Genitore', 'Figlio/a', 'Nessuna Parentela'];

export default function Step2Soggetto({ data, onChange, errors }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Tipo soggetto
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Indica chi sta compilando la richiesta
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <ButtonBase
            onClick={() => onChange('tipo_soggetto', 'richiedente')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              p: 2,
              width: '100%',
              textAlign: 'left',
              borderRadius: 3,
              border: '2px solid',
              transition: 'all 0.2s',
              borderColor: data.tipo_soggetto === 'richiedente' ? 'primary.main' : 'divider',
              bgcolor: data.tipo_soggetto === 'richiedente' ? 'primary.light' : 'transparent',
              '&:hover': { borderColor: 'primary.main', bgcolor: 'primary.light' }
            }}
          >
            <Box sx={{ 
              width: 40, 
              height: 40, 
              borderRadius: '50%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              bgcolor: data.tipo_soggetto === 'richiedente' ? 'primary.main' : 'grey.200',
              color: data.tipo_soggetto === 'richiedente' ? 'primary.contrastText' : 'text.secondary'
            }}>
              <User size={20} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Richiedente</Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>Intestatario della polizza</Typography>
            </Box>
          </ButtonBase>
        </Grid>

        <Grid item xs={12} sm={6}>
          <ButtonBase
            onClick={() => onChange('tipo_soggetto', 'coobbligato')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              p: 2,
              width: '100%',
              textAlign: 'left',
              borderRadius: 3,
              border: '2px solid',
              transition: 'all 0.2s',
              borderColor: data.tipo_soggetto === 'coobbligato' ? 'primary.main' : 'divider',
              bgcolor: data.tipo_soggetto === 'coobbligato' ? 'primary.light' : 'transparent',
              '&:hover': { borderColor: 'primary.main', bgcolor: 'primary.light' }
            }}
          >
            <Box sx={{ 
              width: 40, 
              height: 40, 
              borderRadius: '50%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              bgcolor: data.tipo_soggetto === 'coobbligato' ? 'primary.main' : 'grey.200',
              color: data.tipo_soggetto === 'coobbligato' ? 'primary.contrastText' : 'text.secondary'
            }}>
              <Users size={20} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>Coobbligato</Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>Garante o co-firmatario</Typography>
            </Box>
          </ButtonBase>
        </Grid>
      </Grid>

      <Box sx={{ p: 2, bgcolor: 'action.hover', borderRadius: 3, display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Switch 
              checked={data.ha_coobbligato || false} 
              onChange={e => onChange('ha_coobbligato', e.target.checked)} 
            />
          }
          label={<Typography variant="body2">La pratica prevede un coobbligato?</Typography>}
          sx={{ cursor: 'pointer', m: 0 }}
        />
      </Box>

      {data.ha_coobbligato && (
        <FieldWrapper label="Grado di parentela con il richiedente" required error={errors?.grado_parentela} completed={!!data.grado_parentela}>
          <Select 
            fullWidth 
            size="small" 
            value={data.grado_parentela || ''} 
            onChange={e => onChange('grado_parentela', e.target.value)}
            displayEmpty
          >
            <MenuItem value="" disabled>Seleziona il grado di parentela</MenuItem>
            {PARENTELA_OPTIONS.map(opt => (
              <MenuItem key={opt} value={opt}>{opt}</MenuItem>
            ))}
          </Select>
        </FieldWrapper>
      )}
    </Box>
  );
}